module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/article-10-d8e96c04dd64041e14fc1dea6dbe914a.jpg";